import plansData from "../data/plans.json" with { type: "json" };
import featuresData from "../data/features.json" with { type: "json" };

export const PLANS = plansData.plans;
export const PLAN_DEFAULTS = plansData.defaults;
export const FEATURES = featuresData.features;
export const LIMITS = featuresData.limits;

/** Subscription statuses that keep paid entitlements. */
export const PAID_STATUSES = ["active", "trialing", "past_due", "unpaid", "paused"];

export function getPlan(id) {
  return PLANS.find((plan) => plan.id === id) || PLANS.find((plan) => plan.id === PLAN_DEFAULTS.planId);
}

/** The plan a household is entitled to, given its stored plan and Stripe status. */
export function planForStatus(status, paidPlanId = "plus") {
  return getPlan(PAID_STATUSES.includes(status) ? paidPlanId : PLAN_DEFAULTS.planId);
}

export function hasFeature(plan, featureId) {
  return !!plan && plan.features.includes(featureId);
}

export function limitOf(plan, limitId) {
  const value = plan?.limits?.[limitId];
  if (typeof value !== "number") throw new Error(`Unknown plan limit: ${limitId}`);
  return value;
}

export function featureDetails(plan) {
  return plan.features.map((id) => FEATURES.find((f) => f.id === id)).filter(Boolean);
}
